<template>
  <div class="addAddress absolute">
    <div class="list">
      <div class="item acea-row row-between-wrapper">
        <div class="name">姓名</div>
        <input
          type="text"
          placeholder="请输入姓名"
          v-model="userAddress.realName"
          required
        />
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="name">联系电话</div>
        <input
          type="text"
          placeholder="请输入联系电话"
          v-model="userAddress.phone"
          required
        />
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="name">城市</div>
        <input
          type="text"
          placeholder="请输入城市"
          v-model="userAddress.city"
          required
        />
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="name">区/县</div>
        <input
          type="text"
          placeholder="请输入区/县"
          v-model="userAddress.district"
          required
        />
      </div>
      <div class="item acea-row row-between-wrapper">
        <div class="name">详细地址</div>
        <input
          type="text"
          placeholder="请填写具体地址"
          v-model="userAddress.detail"
          required
        />
      </div>
    </div>
    <div></div>
    <div class="keepBnt bg-color-red" @click="submit">立即保存</div>
  </div>
</template>
<script type="text/babel">
import {getAddress, postAddress} from "@api/user";
import {getCity} from "@api/public";
import {openAddress} from "@libs/wechat";
import {isWeixin} from "@utils";

export default {
  data() {
    return {
      show2: false,
      model2: "",
      district: [],
      id: 0,
      userAddress: {is_default: 0},
      address: {},
      isWechat: isWeixin(),
      ready: false
    };
  },
  mounted: function () {
    let id = this.$route.params.id;
    this.id = id;
    document.title = !id ? "添加地址" : "修改地址";
    this.getUserAddress();
    // this.getCityList();
  },
  methods: {
    getCityList: function () {
      let that = this;
      getCity()
        .then(res => {
          that.district = res.data;
          that.ready = true;
        })
        .catch(err => {
          that.$dialog.error(err.msg);
        });
    },
    getUserAddress: function () {
      if (!this.id) return false;
      let that = this;
      getAddress(that.id)
        .then(res => {
          that.userAddress = res.data;
          that.model2 =
            res.data.province + " " + res.data.city + " " + res.data.district;
          that.address.province = res.data.province;
          that.address.city = res.data.city;
          that.address.city_id = res.data.city_id;
        })
        .catch(err => {
          that.$dialog.error(err.msg);
        });
    },
    getAddress() {
      openAddress().then(userInfo => {
        this.$dialog.loading.open();
        postAddress({
          id: this.id,
          real_name: userInfo.userName,
          phone: userInfo.telNumber,
          address: {
            province: userInfo.provinceName,
            city: userInfo.cityName,
            district: userInfo.countryName
          },
          detail: userInfo.detailInfo,
          is_default: 1,
          post_code: userInfo.postalCode,
          type: 1
        })
          .then(() => {
            this.$dialog.loading.close();
            this.$dialog.toast({mes: "添加成功"});
            this.$router.go(-1);
          })
          .catch(err => {
            this.$dialog.loading.close();
            this.$dialog.error(err.msg || "添加失败");
          });
      });
    },
    async submit() {
      this.userAddress.province = "内蒙古";
      console.log(this.userAddress);
      var addr = this.userAddress.detail.trim();
      // 数据校验
      if (
        this.userAddress.realName === "" ||
        this.userAddress.realName === undefined
      ) {
        this.$dialog.error("请输入姓名");
      } else if (
        this.userAddress.phone === "" ||
        this.userAddress.phone === undefined
      ) {
        this.$dialog.error("请输入电话");
      } else if (
        this.userAddress.city === "" ||
        this.userAddress.city === undefined
      ) {
        this.$dialog.error("请输入城市");
      } else if (
        this.userAddress.district === "" ||
        this.userAddress.district === undefined
      ) {
        this.$dialog.error("请输入区县");
      } else if (
        this.userAddress.detail === "" ||
        this.userAddress.detail === undefined||
        addr === "" ||
        addr === undefined
      ) {
        this.$dialog.error("请输入详细地址");
      } else {
        try {
          let that = this,
            data = that.userAddress;

          postAddress(data)
            .then(function (res) {
              if (res.resultKey === "0") that.$dialog.toast({mes: "创建成功"});
              that.$router.go(-1);
            })
            .catch(err => {
              that.$dialog.error(err.msg);
            });
        } catch (e) {
          this.$dialog.error(e.msg);
        }
      }
    },
    ChangeIsDefault: function () {
      this.userAddress.is_default = !this.userAddress.is_default;
    },
    result2(ret) {
      this.model2 = ret.itemName1 + " " + ret.itemName2 + " " + ret.itemName3;
      this.address.province = ret.itemName1;
      this.address.city = ret.itemName2;
      this.address.city_id = ret.itemValue2;
      this.address.district = ret.itemName3;
    }
  }
};
</script>
